module.exports = __webpack_public_path__ + "img/fd100img.9b52bae4.png";